export default __webpack_public_path__ + "static/media/zod.67d3d19c.png";